import Joi from 'joi';
import { Actions } from '../constants/actions';
import { Permission } from './Authprovider';
import isDefinedFilter from './isDefinedFilter';

export const getMatchingPermissions = <AttributeSchema = unknown>(
  permissions: Permission[] | undefined,
  action: Actions,
  attributesSchema?: Joi.Schema<AttributeSchema>,
) => {
  if (!permissions) return [];

  const matchingPermissions = permissions.filter((permission) => {
    if (typeof permission === 'string') return permission === action;
    return permission.name === action;
  }).map((authenticatorAction) => {
    const normalizedAction = typeof authenticatorAction === 'string'
      ? { name: authenticatorAction, attributes: undefined }
      : authenticatorAction;

    if (!attributesSchema) {
      return normalizedAction as { name: Actions; attributes: AttributeSchema };
    }
    const validatedAttributes = attributesSchema.validate(normalizedAction.attributes);
    if (validatedAttributes.error) return undefined;
    return {
      name: normalizedAction.name,
      attributes: validatedAttributes.value,
    };
  }).filter(isDefinedFilter);

  return matchingPermissions;
};

const hasAccess = <AttributeSchema = unknown>(
  permissions: Permission[] | undefined,
  action: Actions,
  attributesOptions?: {
    schema: Joi.Schema<AttributeSchema>;
    check?: (matchingPermissions: { name: Actions; attributes: AttributeSchema }[]) => boolean;
  },
) => {
  const matchingPermissions = getMatchingPermissions(
    permissions,
    action,
    attributesOptions?.schema,
  );

  const isAllowed = attributesOptions?.check
    ? attributesOptions.check(matchingPermissions)
    : matchingPermissions.length > 0;

  return isAllowed;
};

export default hasAccess;
